import { navigateToObjectTool } from './navigateToObjectTool'
import { globalSearchTool } from './globalSearchTool'
import { sendEmailTool } from './sendEmailTool'
// import { makePhoneCallTool } from './makePhoneCallTool'
import { sendSMSTool } from './sendSMSTool'

export const tools = {
  navigateToObjectTool,
  sendSMSTool,
  globalSearchTool,
  sendEmailTool,
  // makePhoneCallTool,
}
